import { createFileRoute, redirect } from "@tanstack/react-router";

// Keep old verification links usable without interrupting the signed-in session.
export const Route = createFileRoute("/_authed/mfa")({
  validateSearch: (s: Record<string, unknown>): { redirect?: string } => (typeof s.redirect === "string" ? { redirect: s.redirect } : {}),
  beforeLoad: async ({ search }) => {
    const { safeRedirect } = await import("../../../app/auth-card");
    const destination = safeRedirect(search.redirect);
    throw redirect({ href: /[\\\r\n]/.test(destination) || /^\/mfa(?:[/?#]|$)/.test(destination) ? "/" : destination });
  },
});
